import React, { useEffect, useState } from 'react';
import { Button, Modal } from '@material-ui/core';

import { infoTechApi as api } from 'api/infoTech';
import { DataTable, FormComponent, Notifications } from 'shared';

// Table to show who has what role
function ViewUsersWithRoleTable({ parentRow, setExpandedRow }) {
    const [roleID, setRoleID] = useState(parentRow.original.id);
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });

    const columns = [
        { accessor: 'id', Header: 'User ID' },
        { accessor: 'email', Header: 'Email' },
        {
            accessor: 'revoke',
            Header: 'Revoke',
            Cell: ({ cell: { value: initialValue }, column, editable, row, saveEdit }) => (
                <div
                    onClick={(event) => {
                        event.stopPropagation();
                    }}
                >
                    <Button
                        onClick={async () => {
                            const response = await api.revokePermission(row.original.id, roleID);
                            if (response.status === false) {
                                setNotification({
                                    text: `Unable to revoke permissions ${response.msg}`,
                                    level: 'error',
                                });
                                return;
                            }

                            setNotification({ text: 'Permission revoked', level: 'success' });
                        }}
                    >
                        REVOKE
                    </Button>
                </div>
            ),
        },
    ];

    const getItemsInTable = async () => {
        const response = await api.getUsersWithRole(roleID);

        if (response.status === false) {
            setNotification({ text: `No roles found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        setRows(response.data.rows);
    };

    useEffect(() => {
        getItemsInTable();
    }, []);

    return (
        <div className="batch-table">
            <Notifications options={notification} />
            {}
            <DataTable columns={columns} data={rows} />
        </div>
    );
}

function SearchJalapenoRole() {
    const [rows, setRows] = useState([]);
    const [facilities, setFacilities] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });

    const getRoles = async () => {
        const response = await api.getRoles('MISFITS MARKET');

        if (response.status === false) {
            setNotification({ text: `No roles found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        setRows(response.data.rows);
    };

    useEffect(() => {
        getRoles('MISFITS MARKET');
    }, []);

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'description', Header: 'Role' },
    ];

    return (
        <div>
            <h1>Jalapeno Accounts</h1>
            <Notifications options={notification} />

            <div>
                <DataTable columns={columns} data={rows} expandable ExpansionComponent={<ViewUsersWithRoleTable />} />
            </div>
        </div>
    );
}

export { SearchJalapenoRole };
